<div class="container-fluid">
    <app-page-title title="Manage Manifest Inbound"></app-page-title>
    <form [formGroup]="manifestForm" (ngSubmit)="manifestFormSubmitted=true">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <!-- <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="Branch" class="form-label">Branch <span
                                            class="mandatory">*</span></label>
                                    <ng-select id="Branch" [items]="branchList" bindLabel="name" placeholder="Select"
                                        [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlBranch"
                                        aria-readonly="true"
                                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('ddlBranch')?.touched) && manifestForm.get('ddlBranch').errors}">
                                    </ng-select>
                                    <div *ngIf="(manifestFormSubmitted || manifestForm.get('ddlBranch')?.touched) && manifestForm.get('ddlBranch').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="manifestForm.get('ddlBranch').errors.required">Branch is
                                            required</span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-md-2">
                                <div class="mb-2">
                                  <label for="dateTime" class="form-label">Manifest Date <span class="mandatory">*</span></label>
                                  <input type="datetime-local" class="form-control form-control-sm" formControlName="txtDateTime"
                                    [min]="minDateTime" max="3000-12-31T23:59" (input)="validateDate()"
                                    [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('txtDateTime')?.touched) && manifestForm.get('txtDateTime').errors}"  />
                                  <div *ngIf="(manifestFormSubmitted || manifestForm.get('txtDateTime')?.touched) && manifestForm.get('txtDateTime').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="manifestForm.get('txtDateTime').errors.minDate">Manifest Date must be valid</span>
                                  </div>
                                </div>
                              </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="loader" class="form-label">Load Vendor</label>
                                    <ng-select id="loader" bindLabel="name" [items]="loadVendorsList" [bindValue]="'id'"
                                        placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlLoadVendor"  >
                                    </ng-select>
                                </div>
                            </div>
                            
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="remarks" class="form-label">Remarks</label>
                                    <input type="text" class="form-control form-control-sm" id="remarks"
                                        formControlName="txtRemarks"  >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <div class="label">
                                        <label for="status" class="form-label">Manifest For</label>
                                    </div>
                                    <div role="group" aria-label="radio button group" class="btn-group">
                                        <input type="radio" id="btnradio4" autocomplete="off" class="btn-check"
                                            formControlName="manifestFor" value="Branch">
                                        <label for="btnradio4" class="btn btn-outline-secondary btn-sm">Branch</label>
                                        <input type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                                            formControlName="manifestFor" value="Third Party"  >
                                        <label for="btnradio5" class="btn btn-outline-secondary btn-sm">Third
                                            Party</label>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-2" *ngIf="!showVendors">
                                <div class="mb-2">
                                    <label for="servicecenter" class="form-label">Service Center <span
                                            class="mandatory">*</span></label>
                                    <ng-select id="servicecenter" [items]="serviceCenterList" bindLabel="name"
                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                        formControlName="ddlServiceCenter"
                                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('ddlServiceCenter')?.touched) && manifestForm.get('ddlServiceCenter').errors}">
                                    </ng-select>
                                    <div *ngIf="(manifestFormSubmitted || manifestForm.get('ddlServiceCenter')?.touched) && manifestForm.get('ddlServiceCenter').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="manifestForm.get('ddlServiceCenter').errors.required">Service
                                            Center is
                                            required</span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-md-2" *ngIf="showVendors">
                                <div class="mb-2">
                                    <label for="vendor" class="form-label">Vendor<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="vendor" [items]="vendorList" bindLabel="name" placeholder="Select"
                                        [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlVendor"
                                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('ddlVendor')?.touched) && manifestForm.get('ddlVendor').errors}"  >
                                    </ng-select>
                                    <div *ngIf="(manifestFormSubmitted || manifestForm.get('ddlVendor')?.touched) && manifestForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="manifestForm.get('ddlVendor').errors.required">Vendor is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-2">
                            <label for="awbchk" class="form-label">Create AWB ?</label>
                            <div class="form-check form-switch form-switch-md mb-2">
                                <input id="awbchk" type="checkbox" (change)="showAwbForm = !showAwbForm"
                                    class="form-check-input">
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </form>
    <form *ngIf="showAwbForm" [formGroup]="awbDetailsForm">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">AWB DETAILS</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="awbNo" class="form-label">AWB No.<span
                                            class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="awbNo"
                                        formControlName="txtAwbNo"
                                        [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtAwbNo')?.touched) && awbDetailsForm.get('txtAwbNo').errors}"  >
                                    <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtAwbNo')?.touched) && awbDetailsForm.get('txtAwbNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbDetailsForm.get('txtAwbNo').errors.required">AWB No. is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="awbDate" class="form-label">AWB Date<span
                                            class="mandatory">*</span></label>
                                    <input type="date" class="form-control form-control-sm" id="awbDate"
                                        formControlName="txtAwbDate"
                                        [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtAwbDate')?.touched) && awbDetailsForm.get('txtAwbDate').errors}"  >
                                    <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtAwbDate')?.touched) && awbDetailsForm.get('txtAwbDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbDetailsForm.get('txtAwbDate').errors.required">AWB Date is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="Customer" class="form-label">Customer<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="Customer" [items]="customerList" bindLabel="name"
                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                        formControlName="ddlCustomer" (change)="bindCustomerShipperInfo()"
                                        [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('ddlCustomer')?.touched) && awbDetailsForm.get('ddlCustomer').errors}"  >
                                    </ng-select>
                                    <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlCustomer')?.touched) && awbDetailsForm.get('ddlCustomer').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbDetailsForm.get('ddlCustomer').errors.required">Customer is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> SHIPPER </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="shipperName" class="form-label">Name</label>
                                        <input type="text" class="form-control form-control-sm" id="shipperName"
                                            placeholder="Search or Enter Name" formControlName="txtShipper"
                                            [resultTemplate]="rt" [inputFormatter]="formatter" [ngbTypeahead]="search"
                                            (selectItem)="bindshipperlocationdetails($event)"  >
                                        <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                            <span> | {{r['code']}}</span>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="shipperPerson" class="form-label">Person</label>
                                        <input type="text" class="form-control form-control-sm" id="shipperPerson"
                                            formControlName="txtShipperPerson"  >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="shipperEmail" class="form-label">Email</label>
                                        <input type="text" class="form-control form-control-sm" id="shipperEmail"
                                            formControlName="txtShipperEmail"  >
                                    </div>
                                </div>
                            </div>
                            <app-location formGroupName="shipperlocationdetails"
                                [formSubmitted]="awbDetailsFormSubmitted"
                                [location]="shipperLocationInfo"></app-location>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> CONSIGNEE </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="consigneename" class="form-label">Name</label>
                                        <input type="text" class="form-control form-control-sm" id="consigneename"
                                            placeholder="Search or Enter Name" [resultTemplate]="rt"
                                            formControlName="txtConsignee" [inputFormatter]="formatter"
                                            [ngbTypeahead]="search" (selectItem)="bindconsigneelocationdetails($event)"  >
                                        <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="consigneeperson" class="form-label">Person</label>
                                        <input type="text" class="form-control form-control-sm" id="consigneeperson"
                                            formControlName="txtConsigneePerson"  >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="consigneeemail" class="form-label">Email</label>
                                        <input type="text" class="form-control form-control-sm" id="consigneeemail"
                                            formControlName="txtConsigneeEmail"  >
                                    </div>
                                </div>
                            </div>
                            <app-location formGroupName="consigneelocationdetails"
                                [formSubmitted]="awbDetailsFormSubmitted"
                                [location]="consigneeLocationInfo"></app-location>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase"> SERVICE DETAILS</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="Product" class="form-label">Product<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="Product" bindLabel="name" [items]="productList"
                                            formControlName="txtProduct" [bindValue]="'id'" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" (change)="onChangeProduct($event)"
                                            [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtProduct')?.touched) && awbDetailsForm.get('txtProduct').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtProduct')?.touched) && awbDetailsForm.get('txtProduct').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbDetailsForm.get('txtProduct').errors.required">Product is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="Vendor" class="form-label">Vendor<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="Vendor" bindLabel="name" [items]="vendorList" [bindValue]="'id'"
                                            placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="txtVendor"
                                            (change)="getAllVendorServices()"
                                            [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtVendor')?.touched) && awbDetailsForm.get('txtVendor').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtVendor')?.touched) && awbDetailsForm.get('txtVendor').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbDetailsForm.get('txtVendor').errors.required">Vendor is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="VendorService" class="form-label">Vendor Service<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="VendorService" bindLabel="servicename"
                                            formControlName="txtVendorService" [items]="vendorServiceList"
                                            [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtVendorService')?.touched) && awbDetailsForm.get('txtVendorService').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtVendorService')?.touched) && awbDetailsForm.get('txtVendorService').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbDetailsForm.get('txtVendorService').errors.required">Vendor
                                                Service is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="ShipmentValue" class="form-label">Shipment Value<span
                                                class="mandatory">*</span></label>
                                        <input id="ShipmentValue" type="number" class="form-control form-control-sm"
                                            formControlName="txtShipmentValue"
                                            [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtShipmentValue')?.touched) && awbDetailsForm.get('txtShipmentValue').errors}"  >
                                        <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtShipmentValue')?.touched) && awbDetailsForm.get('txtShipmentValue').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="awbDetailsForm.get('txtShipmentValue').errors.mandatory">Shipment
                                                Value is Required</span>
                                            <span *ngIf="awbDetailsForm.get('txtShipmentValue').errors.patten">Enter
                                                Upto 6 Digits Only</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="PaymentMode" class="form-label">Payment Mode<span
                                                class="mandatory">*</span></label>
                                        <ng-select id="PaymentMode" bindLabel="name" [items]="PaymentModeList"
                                            placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlPaymentMode"
                                            [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('ddlPaymentMode')?.touched) && awbDetailsForm.get('ddlPaymentMode').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlPaymentMode')?.touched) && awbDetailsForm.get('ddlPaymentMode').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="awbDetailsForm.get('ddlPaymentMode').errors.required"> Payment
                                                Mode is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-header bg-transparent border-bottom text-uppercase">PIECES DETAILS</div>
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="pieces" class="form-label">Pieces<span *ngIf="piecesMandate"
                                        class="mandatory">*</span></label>
                                <input type="number" class="form-control form-control-sm" id="pieces"
                                    formControlName="txtPieces" (change)="generateRowsOrSave()"
                                    [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtPieces')?.touched) && awbDetailsForm.get('txtPieces').errors}"  >
                                <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtPieces')?.touched) && awbDetailsForm.get('txtPieces').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="awbDetailsForm.get('txtPieces').errors.required">Pieces are
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="piecesunit" class="form-label">Measurement Unit<span *ngIf="piecesMandate"
                                        class="mandatory">*</span></label>
                                <ng-select id="piecesunit" bindLabel="label" [bindValue]="'value'" [items]="unitList"
                                    placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlPiecesUnit"
                                    (change)="calculatePiecesDetails()"
                                    [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('ddlPiecesUnit')?.touched) && awbDetailsForm.get('ddlPiecesUnit').errors}"  >
                                </ng-select>
                                <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlPiecesUnit')?.touched) && awbDetailsForm.get('ddlPiecesUnit').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="awbDetailsForm.get('ddlPiecesUnit').errors.required">Unit is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="actualWeight" class="form-label"> Actual Weight<span *ngIf="piecesMandate"
                                        class="mandatory">*</span></label>
                                <input type="number" class="form-control form-control-sm" id="actualWeight"
                                    formControlName="txtTotalActualWeight" (keyup)="calculateTotalWVC()"
                                    [ngClass]="{'is-invalid':(awbDetailsFormSubmitted || awbDetailsForm.get('txtTotalActualWeight')?.touched) && awbDetailsForm.get('txtTotalActualWeight').errors}"  >
                                <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtTotalActualWeight')?.touched) && awbDetailsForm.get('txtTotalActualWeight').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="awbDetailsForm.get('txtTotalActualWeight').errors.required">Actual
                                        Weight required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="volumetricweight" class="form-label"> Volumetric Weight</label>
                                <input type="number" class="form-control form-control-sm" id="volumetricweight"
                                    formControlName="txtTotalVolumetricWeight" (keyup)="calculateTotalWVC()"  >
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="chargeableWeight" class="form-label"> Chargeable Weight</label>
                                <input type="number" class="form-control form-control-sm" id="chargeableWeight"
                                    formControlName="txtTotalChargeableWeight"  >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-sm m-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Sr.No.</th>
                                        <th>Actual Weight/Piece<span class="mandatory">*</span></th>
                                        <th>Length</th>
                                        <th>Breadth</th>
                                        <th>Height</th>
                                        <th>Volumetric Weight</th>
                                        <th>Chargeable Weight</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let p of piecesDetailsList; let i = index">
                                        <th>{{i+1}}</th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.actualweight" name="actualWeight{{ i }}"
                                                [ngModelOptions]="{standalone: true}"
                                                (keyup)="calculatePiecesDetails(p)"  >
                                        </th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.piecelength" name="length{{ i }}"
                                                [ngModelOptions]="{standalone: true}"
                                                (keyup)="calculatePiecesDetails(p)"  >
                                        </th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.piecebreadth" name="breadth{{ i }}"
                                                [ngModelOptions]="{standalone: true}"
                                                (keyup)="calculatePiecesDetails(p)"  >
                                        </th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.pieceheight" name="height{{ i }}"
                                                [ngModelOptions]="{standalone: true}"
                                                (keyup)="calculatePiecesDetails(p)"  >
                                        </th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.volumetricweight" disabled
                                                [ngModelOptions]="{standalone: true}"  >
                                        </th>
                                        <th>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="p.chargeableweight" disabled
                                                [ngModelOptions]="{standalone: true}"  >
                                        </th>
                                        <th>
                                            <i class="bx bx-trash font-size-16 align-middle ms-3" title="Delete"
                                                (click)="deleteRow(i)"></i>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class=" col-md-12">
                            <div class="row mb-3">
                                <div class="col-12">
                                    <button type="button" class="btn btn-primary waves-effect btn-label waves-light btn-sm w-md"
                                        (click)="onMarkReceived()" [disabled]="btnMarkReceivedDisabled">
                                        <i class="bx bx-check-double label-icon"></i>Received</button>
                                    <!-- <div class="button-items">
                                        <button type="button" class="btn btn-primary btn-sm w-md" >Mark Received</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label class="form-label custom-info-label">
                            <i class="mdi mdi-alert-circle-outline me-1"></i> 
                            Note: Please select AWBs from below list and click "Received" button to mark them received
                        </label>
                    </div>
                    <div class="row" *ngIf="this.permConfig.isViewAllowed">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true" [enableCellTextSelection]="true"
                                (gridReady)="onGridReady($event)" (rowSelected)="onRowSelected($event)"
                                [gridOptions]="gridOptions" [isRowSelectable]="isRowSelectable"> 
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <!-- <div class="alert alert-dark alert-dismissible fade show" role="alert">
            <i class="mdi mdi-alert-outline me-2"></i>
            Please click on the checkbox for received shipments.
        </div> -->
        
        
    <div class="col-12">
        <div class="row mb-3 mt-3">
            <div class="button-items">
                <a routerLink="/operation/manifests" >
                    <button type="button" class="btn btn-secondary w-md">Back</button>
                </a>
            </div>
        </div>
    </div>
    
</div>